const gallery = document.querySelector("[data-media-gallery]");
if (gallery) {
  const stage = gallery.querySelector("[data-media-stage]");
  const realItems = [...gallery.querySelectorAll("[data-media-item]")];
  const status = gallery.querySelector("[data-media-status]");
  const dots = [...gallery.querySelectorAll("[data-media-dot]")];
  const dialog = gallery.querySelector("[data-media-dialog]");
  const frame = gallery.querySelector("[data-media-dialog-frame]");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const loop = Boolean(stage && realItems.length > 1);
  let index = 0;
  let zoomTrigger = null;
  let jumping = false;
  let lastClone = null;
  let firstClone = null;

  function wrap(nextIndex) {
    const total = realItems.length;
    if (total === 0) return 0;
    return ((nextIndex % total) + total) % total;
  }

  function slideLabel(current, total) {
    const template = status?.dataset.template;
    if (template) return template.replace("{{ current }}", current).replace("{{ total }}", total);
    return `${current} / ${total}`;
  }

  function pauseOffscreenVideo() {
    realItems.forEach((item, itemIndex) => {
      const video = item.querySelector("[data-video-el]");
      if (!video || itemIndex === index) return;
      video.pause?.();
    });
  }

  function markCurrent(nextIndex) {
    index = wrap(nextIndex);
    realItems.forEach((item, itemIndex) => {
      const current = itemIndex === index;
      item.classList.toggle("is-current", current);
      item.setAttribute("aria-hidden", current ? "false" : "true");
    });
    dots.forEach((dot, dotIndex) => {
      const current = dotIndex === index;
      dot.classList.toggle("is-current", current);
      dot.setAttribute("aria-current", current ? "true" : "false");
    });
    if (status) status.textContent = slideLabel(index + 1, realItems.length);
    pauseOffscreenVideo();
  }

  function scrollToItem(item, behavior) {
    if (!stage || !item) return;
    stage.scrollTo({ left: item.offsetLeft, behavior });
  }

  function jumpTo(item) {
    if (!stage || !item) return;
    jumping = true;
    scrollToItem(item, "instant");
    window.requestAnimationFrame(() => {
      jumping = false;
    });
  }

  function goTo(nextIndex, { scroll = false } = {}) {
    const total = realItems.length;
    if (total === 0) return;
    const wrapped = wrap(nextIndex);
    if (!scroll) {
      markCurrent(wrapped);
      return;
    }
    const motion = reduceMotion ? "instant" : "smooth";
    if (loop && index === total - 1 && wrapped === 0 && firstClone) {
      markCurrent(0);
      scrollToItem(firstClone, motion);
      return;
    }
    if (loop && index === 0 && wrapped === total - 1 && lastClone) {
      markCurrent(total - 1);
      scrollToItem(lastClone, motion);
      return;
    }
    markCurrent(wrapped);
    scrollToItem(realItems[wrapped], motion);
  }

  function syncFromScroll() {
    if (!stage || jumping || realItems.length === 0) return;
    const width = stage.clientWidth;
    if (!width) return;
    const slide = Math.round(stage.scrollLeft / width);
    if (loop) {
      if (slide <= 0) {
        markCurrent(realItems.length - 1);
        jumpTo(realItems[realItems.length - 1]);
        return;
      }
      if (slide >= realItems.length + 1) {
        markCurrent(0);
        jumpTo(realItems[0]);
        return;
      }
      markCurrent(slide - 1);
      return;
    }
    markCurrent(slide);
  }

  function openZoom(host) {
    const item = host.closest("[data-media-item]") || host;
    const image = item.querySelector("img");
    if (!image || !dialog || !frame) return;
    zoomTrigger = host;
    const zoomed = image.cloneNode(true);
    const src = host.dataset.zoomSrc || item.dataset.zoomSrc;
    if (src) {
      zoomed.src = src;
      zoomed.removeAttribute("srcset");
      zoomed.removeAttribute("sizes");
    }
    frame.replaceChildren(zoomed);
    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "");
  }

  if (loop) {
    lastClone = realItems[realItems.length - 1].cloneNode(true);
    firstClone = realItems[0].cloneNode(true);
    [lastClone, firstClone].forEach((clone) => {
      clone.classList.remove("is-current");
      clone.removeAttribute("id");
      clone.setAttribute("aria-hidden", "true");
      clone.querySelectorAll("[id]").forEach((node) => node.removeAttribute("id"));
    });
    lastClone.dataset.clone = "start";
    firstClone.dataset.clone = "end";
    lastClone.dataset.mediaIndex = String(realItems.length - 1);
    firstClone.dataset.mediaIndex = "0";
    stage.prepend(lastClone);
    stage.append(firstClone);
    jumpTo(realItems[0]);
    window.requestAnimationFrame(() => jumpTo(realItems[0]));
  }

  gallery.dataset.enhanced = "true";
  if (status) {
    status.dataset.template = status.textContent.includes("/")
      ? status.textContent.replace(/\d+\s*\/\s*\d+/, "{{ current }} / {{ total }}")
      : "{{ current }} / {{ total }}";
  }

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      goTo(Number(dot.dataset.mediaIndex), { scroll: true });
    });
  });

  if (stage && realItems.length > 1) {
    let scrollTick = 0;
    stage.addEventListener(
      "scroll",
      () => {
        window.clearTimeout(scrollTick);
        scrollTick = window.setTimeout(syncFromScroll, 90);
      },
      { passive: true }
    );
    stage.addEventListener("scrollend", syncFromScroll);
    stage.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goTo(index - 1, { scroll: true });
      }
      if (event.key === "ArrowRight") {
        event.preventDefault();
        goTo(index + 1, { scroll: true });
      }
    });
    window.addEventListener("resize", () => {
      jumpTo(realItems[index]);
    });
  }

  let pointer = null;
  gallery.addEventListener("pointerdown", (event) => {
    if (!event.target.closest("[data-media-zoom]")) return;
    pointer = { x: event.clientX, y: event.clientY };
  });
  gallery.addEventListener("click", (event) => {
    if (event.target.closest("[data-video-play], [data-media-dot], .media-zoom")) return;
    const host = event.target.closest("[data-media-zoom]");
    if (!host) return;
    if (pointer && Math.hypot(event.clientX - pointer.x, event.clientY - pointer.y) > 12) return;
    openZoom(host);
  });
  gallery.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    const host = event.target.closest("[data-media-zoom]");
    if (!host || event.target !== host) return;
    event.preventDefault();
    openZoom(host);
  });

  dialog?.addEventListener("close", () => {
    if (zoomTrigger?.focus) zoomTrigger.focus();
    zoomTrigger = null;
    frame?.replaceChildren();
  });

  gallery.querySelectorAll("[data-video-play]").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.stopPropagation();
      const host = button.closest("[data-media-video]");
      const video = host?.querySelector("[data-video-el]");
      if (!video) return;
      button.hidden = true;
      video.hidden = false;
      video.play?.();
    });
  });

  markCurrent(0);
}
